import axios from "axios";
import {
    IP
} from "../index";

/* 柜门管理 */

// 查询
export async function select() {
    var resp = await axios.post(`${IP}/admin/openBoxList/select`, {

    });
    return resp.data;
}
// 删除
export async function deleteApi(id) {
    var resp = await axios.post(`${IP}/admin/openBoxList/delete`, {
        id
    });
    return resp.data;
}

// 新增
export async function add(data) {
    var resp = await axios.post(`${IP}/admin/openBoxList/add`, {
        ...data
    });
    return resp.data;
}

// 修改
export async function update(data) {
    var resp = await axios.post(`${IP}/admin/openBoxList/update`, {
        ...data
    });
    return resp.data;
}